import appendStyles from './AddItems/AddStyles';
import appendCollapseButton, {
    collapseView,
    isSavedAsCollapsed,
} from './AddItems/AppendCollapseButton';
import appendLogo from './AddItems/AppendLogo';
import { appendMenuItems } from './AddItems/AppendMenuItems';
import {
    appendReorderButton,
    applySavedMenuItemOrder,
    initReorderMode,
} from './AddItems/ReorderMode';
import { renderBanner } from 'ff/common/components/FFMenuV2/Banner/RenderBanner';
import { appendPopup } from 'ff/common/components/FFMenuV2/AddItems/AppendPopup';
import { InitialMenuState } from 'shared/sharedTypes/ffmenu/InitialMenuState';
import { RenderMenuParams } from 'ff/common/components/FFMenuV2/RenderMenuParams';

declare global {
    interface Window {
        renderMenu: (activeMenu: string, params: RenderMenuParams) => void;
        notifications: Record<string, unknown>;
    }
}

const renderMenu = (activeMenu: string, params: RenderMenuParams) => {
    console.log(
        `FFMenu build version: ${
            process.env.BUILD_VERSION || 'not supplied'
        }. Menu Config FFMenu build config: ${
            params.ffmenuBuildVersion || 'not supplied'
        }.`
    );
    const {
        currentUser,
        featureFlags,
        notifications,
        serverEnv,
        fspUser,
        isActive,
    } = params;
    //In case these werent set by the host app, set them there (bc this code expects them to be set)
    window.activeMenu = window.activeMenu || activeMenu;
    window.currentUser = window.currentUser || currentUser;
    window.featureFlags = window.featureFlags || featureFlags;
    window.notifications = window.notifications || notifications;
    window.serverEnv = window.serverEnv || serverEnv;
    window.fspUser = window.fspUser || fspUser;
    window.isActive = window.isActive || isActive;

    renderSideMenu(params);
    renderBanner(params);
    // renderMilitaryAdModal(params);
};

export default renderMenu;
window.renderMenu = renderMenu;

function renderSideMenu(params: RenderMenuParams) {
    const root = document.getElementById('ffweb-side-menu');
    if (!root) {
        return;
    }
    let shadowRoot;
    if (root.shadowRoot) {
        //If the menu is rerendered and there is already a shadow root, clear it and use it to fill up again
        root.shadowRoot.innerHTML = '';
        shadowRoot = root.shadowRoot;
    } else {
        //Shadow root lets us add styles that are isolated from the rest of the dom. DOM styles won't
        // affect anything in the shadow root, and styles in the shadow root wont affect the rest of the DOM
        shadowRoot = root.attachShadow({ mode: 'open' });
    }

    const initializedState = params?.initialize?.initializedState;
    if (initializedState === InitialMenuState.EXPANDED) {
        //no op. Menu defaults to expanded.
    } else if (
        isSavedAsCollapsed() ||
        initializedState === InitialMenuState.COLLAPSED
    ) {
        //Do this first things before things get added to avoid flashing expanded vs collapse
        root.classList.add('x-collapse');
    } else if (initializedState === InitialMenuState.HIDDEN) {
        root.style.display = 'none';
    }

    appendStyles(shadowRoot);
    appendCollapseButton(shadowRoot, params);
    if (params.featureFlags?.['reorder_ffmenu'])
        appendReorderButton(shadowRoot);
    appendLogo(shadowRoot);
    appendMenuItems(params, shadowRoot);
    if (params.featureFlags?.['reorder_ffmenu']) {
        initReorderMode(shadowRoot, params);
        applySavedMenuItemOrder(shadowRoot, params);
    }

    if (
        isSavedAsCollapsed() ||
        params?.initialize?.initializedState === InitialMenuState.COLLAPSED
    ) {
        collapseView(shadowRoot, true);
    }

    initSubSectionStyles(shadowRoot);

    appendPopup(shadowRoot);
}

function initSubSectionStyles(root: ShadowRoot) {
    const subSections = root.querySelectorAll<HTMLElement>(
        '.sub-section-contents'
    );
    subSections.forEach(el => {
        let initiallyClosed = false;
        if (el.classList.contains('sub-section-collapse')) {
            el.classList.remove('sub-section-collapse');
            initiallyClosed = true;
        }
        const x = getComputedStyle(el);
        //get the height so we can explicitly set it, so height animation works
        el.style.height = x.getPropertyValue('height');
        if (initiallyClosed) {
            el.classList.add('sub-section-collapse');
        }
    });
}
